import { useMemo, type ReactNode } from "react";
import { NPool, NRelay1 } from "@nostrify/nostrify";
import { NostrContext } from "@nostrify/react";

/**
 * Relays used to resolve profile metadata and (for remote signers)
 * NIP-46 traffic. Login itself (extension / nsec) needs no relay; these
 * are only used to look up the logged-in user's display name/avatar.
 */
const RELAYS = [
  "wss://relay.ditto.pub/",
  "wss://relay.damus.io/",
  "wss://nos.lol/",
];

/**
 * Minimal Nostr pool provider. Supplies the `nostr` object consumed by
 * `useNostr()` / `useCurrentUser()`. Ported (simplified) from
 * treasures.to — no NIP-42 AUTH wiring, since this tool only reads.
 */
export function NostrProvider({ children }: { children: ReactNode }) {
  const pool = useMemo<NPool>(() => {
    return new NPool({
      open: (url: string) => new NRelay1(url),
      reqRouter: (filters) => new Map(RELAYS.map((url) => [url, filters])),
      eventRouter: () => RELAYS,
    });
  }, []);

  return (
    <NostrContext.Provider value={{ nostr: pool }}>
      {children}
    </NostrContext.Provider>
  );
}
